import {Component, Input, AfterViewInit, OnInit, ViewEncapsulation, Inject, Injector, PLATFORM_ID} from '@angular/core';
import {AbstractComponent} from '../abstract.component';
import {isPlatformBrowser} from '@angular/common';
import {GoogleAds} from "../../model/landingModel";
import { AdsBannersService } from 'projects/common/services/ads-banners.service';

declare var window: any;
declare var googletag: any;

export enum AdType {
  BANNER_HOME_DYNAMIC1 = 'BannerHome_Dynamic_312x270_3',
  BANNER_HOME_DYNAMIC2 = 'BannerHome_Dynamic_312x270_4',
  REGULAR1 = 'regular1',
  REGULAR2 = 'regular2',
  REGULAR3 = 'regular3',
  REGULAR4 = 'regular4',
  REGULAR5 = 'regular5',
  REGULAR6 = 'regular6',
  BOTTOM_SQUARE = '300x250',
  BANNER_HOME_FULL1 = 'BannerHome_Dynamic_1280x338_1',
  BANNER_HOME_FULL2 = 'BannerHome_Dynamic_1280x338_2',
  BANNER_HOME_FULL3 = 'BannerHome_Dynamic_1280x338_3',
  BANNER_HOME_FULL4 = 'BannerHome_Dynamic_1280x338_4',
  BANNER_HOME_FULL5 = 'BannerHome_Dynamic_1280x338_5',
  BANNER_HOME_FULL6 = 'BannerHome_Dynamic_1280x338_6',
  BANNER_HOME_MOBILE_FULL1 = 'BannerHome_Dynamic_360x164_1',
  BANNER_HOME_MOBILE_FULL2 = 'BannerHome_Dynamic_360x164_2',
  BANNER_HOME_MOBILE_FULL3 = 'BannerHome_Dynamic_360x164_3',
  BANNER_HOME_MOBILE_FULL4 = 'BannerHome_Dynamic_360x164_4',
  BANNER_HOME_MOBILE_FULL5 = 'BannerHome_Dynamic_360x164_5',
  BANNER_HOME_MOBILE_FULL6 = 'BannerHome_Dynamic_360x164_6',
}

@Component({
  selector: 'ads-banners',
  template: `
    <div id="{{adsIdPrefix}}{{bannerType}}"></div>
  `,
  styleUrls: ['./ads-banners.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdsBannersComponent extends AbstractComponent implements AfterViewInit, OnInit {
  private MODULE_ID: string = "AdsBannersModule";
  private sizeByType = new Map<string, Array<any>>([
    [AdType.BANNER_HOME_DYNAMIC1, ['fluid']],
    [AdType.BANNER_HOME_DYNAMIC2, ['fluid']],
    [AdType.BANNER_HOME_FULL1, ['fluid']],
    [AdType.BANNER_HOME_FULL2, ['fluid']],
    [AdType.BANNER_HOME_FULL3, ['fluid']],
    [AdType.BANNER_HOME_FULL4, ['fluid']],
    [AdType.BANNER_HOME_FULL5, ['fluid']],
    [AdType.BANNER_HOME_FULL6, ['fluid']],
    [AdType.BANNER_HOME_MOBILE_FULL1, ['fluid']],
    [AdType.BANNER_HOME_MOBILE_FULL2, ['fluid']],
    [AdType.BANNER_HOME_MOBILE_FULL3, ['fluid']],
    [AdType.BANNER_HOME_MOBILE_FULL4, ['fluid']],
    [AdType.BANNER_HOME_MOBILE_FULL5, ['fluid']],
    [AdType.BANNER_HOME_MOBILE_FULL6, ['fluid']],
    [AdType.REGULAR1, [750, 140]],
    [AdType.REGULAR2, [510, 140]],
    [AdType.REGULAR3, [630, 140]],
    [AdType.REGULAR4, [630, 140]],
    [AdType.REGULAR5, [630, 140]],
    [AdType.REGULAR6, [630, 140]],
    [AdType.BOTTOM_SQUARE, [300, 250]]
  ]);

  @Input() bannerType: AdType;
  @Input() moduleId: string;
  adsIdPrefix = 'div-gpt-ad-';

  initialized: {[key: string]: boolean} = {};

  constructor(
    injector: Injector,
    @Inject(PLATFORM_ID) private platformId: string,
    private adsBannersService: AdsBannersService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.MODULE_ID = this.moduleId;
  }

  ngAfterViewInit(): void {
    let googleAdsData = this.landingModelService.getLandingModel().googleAds;
    if (googleAdsData.enabled && this.bannerType) {
      this.adsBannersService.loadGoogleTagManager();

      this.fillAdSlot(googleAdsData);
    }
  }

  fillAdSlot(googleAdsData: GoogleAds) {
    if (isPlatformBrowser(this.platformId) && !this.initialized[this.bannerType]) {
      let adsAccount = googleAdsData.google_ads_account;
      let adsId = googleAdsData.google_ads_id;
      let country = googleAdsData.country;
      let product = googleAdsData.product;
      let adType = this.bannerType;
      let size = this.getSizeByType(adType);
      let slot = this.addSlotPrefix(adType);

      window.googletag = window.googletag || {cmd: []};
      window.googletag.cmd = window.googletag.cmd || [];
      window.googletag.cmd.push(function () {
        window.googletag
          .defineSlot('/' + adsAccount + '/' + adsId + '/' + country + '/' + product + '/home/' + adType, size, slot)
          ?.addService(window.googletag.pubads());
        window.googletag.enableServices();
      });

      this.pushAdBanner(slot);
      this.initialized[adType] = true;
    }
  }

  private pushAdBanner(id) {
    window.googletag.cmd.push(function () {
      window.googletag.display(id);
    });
  }

  private getSizeByType(adType: AdType) {
    return this.sizeByType.get(adType);
  }

  private addSlotPrefix(adType: AdType) {
    return this.adsIdPrefix + adType
  }

  getModuleId(): string {
    return this.MODULE_ID;
  }
}
